/* eslint-disable jsx-a11y/control-has-associated-label */
import { type FC } from 'react';

const ActivitySkeletonTableRow: FC = () => (
  <tr className="Table__row">
    <td className="Table__cell ActivityTable__cell">
      <div className="Table__cell-content ActivityTable__cell-content Table__cell-content--loading" />
    </td>
    <td className="Table__cell ActivityTable__cell">
      <div className="Table__cell-content ActivityTable__cell-content Table__cell-content--loading" />
    </td>
    <td className="Table__cell ActivityTable__cell">
      <div className="Table__cell-content ActivityTable__cell-content Table__cell-content--loading" />
    </td>
    <td className="Table__cell ActivityTable__cell">
      <div className="Table__cell-content ActivityTable__cell-content Table__cell-content--loading" />
    </td>
  </tr>
);

interface ActivitySkeletonTableProps {
  rowCount: number;
}

const ActivitySkeletonTable: FC<ActivitySkeletonTableProps> = ({ rowCount }) =>
  Array.from({ length: rowCount }, (_value, index) => (
    <ActivitySkeletonTableRow key={`ActivitySkeletonTable${index}`} />
  ));

export default ActivitySkeletonTable;
